// stores/patientsCombo.js - فقط برای استفاده در کامپوننت select
import { createGenericStore } from './genericStore';

export const useServiceComboStore = createGenericStore(
  'serviceCombo', // نام متفاوت برای store
  '/MatabService/GetAllAsync',
  {
    searchColumns: ['F_scode', 'F_sname'],
    orderBy: 'F_sauto DESC'
  }
);